<ng-container *ngIf="item && stockWrapper.current">
  <app-mini-chart
    #chart
    *ngIf="stockWrapper"
    [stockWrapper]="stockWrapper"
    (click)="itemClicked.emit()"
    (dblclick)="itemDblClicked.emit()"
  ></app-mini-chart>
</ng-container>
